module.exports = __webpack_public_path__ + "media/images/flags/GE-d65942e5f35ecb41808010cef82a6a78.svg";